export default (str = '') => String(str).toLowerCase().trim();
